'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductAccordion = function ProductAccordion(el) {
  var _this = this;

  (0, _classCallCheck3.default)(this, ProductAccordion);

  var context = { context: el };

  this.els = {
    el: el,
    openers: (0, _functional.getElements)('.prd-AccordionOpener', context),
    bodies: (0, _functional.getElements)('.prd-AccordionBody', context)
  };

  this.els.openers.forEach(function (item) {
    item.addEventListener('click', function () {
      _this.els.bodies.forEach(function (body) {
        body.classList.remove('prd-AccordionBody-open');
      });
      _this.els.openers.forEach(function (opener) {
        opener.classList.remove('prd-AccordionOpener-open');
      });
      item.classList.add('prd-AccordionOpener-open');
      (0, _functional.getElement)('.prd-AccordionBody[data-opener=' + item.getAttribute('data-opener') + ']').classList.add('prd-AccordionBody-open');
    });
  });
};

exports.default = ProductAccordion;